import NsTrack from "./track";
import {trackUrl,appCode} from './url'


export const initTrack = (app) => {
  const user = JSON.parse(window.localStorage.getItem("userInfo")) || {};
  const {
    userName,
    userId,
    email,
    code: userNo,
    userType,
    phoneNumber,
    clientId,
  } = user;
  // 埋点
  app.use(NsTrack, {
    appCode,
    global: true,
    url: trackUrl,
    userInfo: {
      userName,
      userId,
      email,
      userNo,
      userType,
      phoneNumber,
      clientId,
    },
  });
};
